import React, { FC, useCallback, useMemo } from "react"
import { Loader, Text } from "dash-styled"
import { useDispatch } from "react-redux"
import { loadMoreCustomerAppList } from "../../../../../../Actions/API/Backoffice/BackofficeActions"
import { openProject } from "../../../../../../Actions/API/Collaborator/CollaboratorActions"
import { selectUserName } from "../../../../../../Helpers/Functions/Selectors/auth"
import { useCustomerAppList } from "../../../../../../Hooks/useCustomerAppList"
import { useAppState } from "../../../../../../Hooks/useReduxState"
import { APIAppInstanceModel } from "../../../../../../Models/API/AppInstanceModel"
import { hasValue } from "../../../../../../Models/Client/FetchState"
import { ListView } from "../../../../../Common/ListView/ListView"
import { CustomerAppGroup } from "./CustomerAppGroup"
import { Customer } from "../../../../../../Models/API/BackofficeModel"

interface CustomerAppListProps {
    customer: Customer
}
export const CustomerAppList: FC<CustomerAppListProps> = ({ customer }) => {
    const dispatch = useDispatch()
    const appListFetch = useCustomerAppList(customer)
    const handleLoadMore = useCallback(async () => {
        dispatch(loadMoreCustomerAppList(customer))
    }, [dispatch, customer])

    const groupedApps: [string, APIAppInstanceModel[]][] = useMemo(() => {
        if (!hasValue(appListFetch)) {
            return []
        }
        return Object.entries(
            appListFetch.value.items.reduce((group, app) => {
                const groupName = app.role ?? app.workerRole ?? "No Role"
                if (group[groupName] === undefined) {
                    group[groupName] = []
                }
                group[groupName].push(app)
                return group
            }, {} as { [group: string]: APIAppInstanceModel[] })
        )
    }, [appListFetch])

    const myUsername = useAppState(selectUserName)

    const handleOpenProject = useMemo(() => {
        if (myUsername === undefined) {
            return undefined
        }
        return (appID: string) => dispatch(openProject(myUsername, appID))
    }, [dispatch, myUsername])

    if (!hasValue(appListFetch)) {
        return <Loader />
    }
    const itemView = ([groupName, apps]: [string, APIAppInstanceModel[]]) => (
        <CustomerAppGroup
            key={groupName}
            groupName={groupName}
            apps={apps}
            onOpenProject={handleOpenProject}
        />
    )
    return (
        <>
            <Text size="xl" weight="semibold" className="mt-4">
                Projects
            </Text>
            <div className="overflow-y-auto">
                <ListView
                    data={groupedApps}
                    item={itemView}
                    loadMore={handleLoadMore}
                    totalCount={appListFetch.value.total}
                />
            </div>
        </>
    )
}
